module.exports = __webpack_public_path__ + "img/succ.6c3708b3.png";